import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_INFO_GROUP,
  GET_INFO_GROUPS,
  ADD_INFO_GROUP,
  UPDATE_INFO_GROUP,
  DELETE_INFO_GROUP
} from '@/queries/modules/university-news/info-group';

export async function getInfoGroups(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_GROUPS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getInfoGroups
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getInfoGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_GROUP,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getInfoGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addInfoGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_INFO_GROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addInfoGroup.nameLocal));

      return data.addInfoGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateInfoGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_INFO_GROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateInfoGroup.nameLocal));

      return data.updateInfoGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteInfoGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_INFO_GROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess(data.deleteInfoGroup.nameLocal));

      return data.deleteInfoGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

